export default {
  uri: "https://lenox-corporation-qa.myshopify.com/api/graphql", // dev
  key: "ab6efd5d27fd102cde47433c7e2175e3"  // dev
}



// WEBPACK FOOTER //
// ../assets/js/personalize/storefrontConfig.js